<template>
  <div class="signup-page">
    <!-- Decorative Elements -->
    <div class="decorative-circle large top-right"></div>
    <div class="decorative-circle large bottom-left"></div>
    <div class="decorative-circle small-yellow top-left"></div>
    <div class="decorative-circle small-blue center-right"></div>
    <div class="decorative-circle small-white bottom-right"></div>
    
    <div class="signup-container">
      <div class="brand-container">
        <img src="../assets/images/UP_SKOOL_LOGO.png" alt="Logo" class="logo" />
        <h2 class="title">Start Your <span class="title-highlight">Learning Journey</span></h2>
        <p class="subtitle">Join the Up-skool community and discover a world of interactive learning for your child</p>
      </div>
      
      <div class="form-grid">
        <!-- Left Column - Personal Information -->
        <div class="glass-card personal-info">
          <div class="card-accent yellow"></div>
          <div class="section-header">
            <div class="section-icon">
              <span class="icon-emoji">👤</span>
            </div>
            <h3>Personal Information</h3>
          </div>
          
          <div class="form-group">
            <label for="parent-name">Parent's name <span class="required">*</span></label>
            <div class="input-wrapper">
              <input type="text" id="parent-name" v-model="signupDetails.name" />
            </div>
          </div>
          
          <div class="form-group">
            <label>Child's name <span class="required">*</span></label>
            <div v-for="(kid, kid_i) in signupDetails.kids" :key="kid_i" class="input-row">
              <div class="input-wrapper flex-grow">
                <input type="text" v-model="signupDetails.kids[kid_i]" />
              </div>
              <button class="btn btn-icon btn-add" @click="addRow()">+</button>
              <button class="btn btn-icon btn-remove" @click="deleteRow(kid_i)" v-if="signupDetails.kids.length > 1">-</button>
            </div>
          </div>
          
          <div class="form-group">
            <label for="email">Email address <span class="required">*</span></label>
            <div class="input-wrapper">
              <input type="email" id="email" v-model="signupDetails.email" />
            </div>
          </div>
          
          <div class="form-group">
            <label for="confirm-email">Confirm email address <span class="required">*</span></label>
            <div class="input-wrapper">
              <input type="email" id="confirm-email" v-model="signupDetails.email1" />
            </div>
          </div>
          
          <div class="form-group">
            <label for="mobile">Mobile number <span class="required">*</span></label>
            <div class="input-wrapper">
              <input type="text" id="mobile" v-model="signupDetails.mobile" maxlength="10" />
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label for="password">Password <span class="required">*</span></label>
              <div class="input-wrapper">
                <input type="password" id="password" v-model="signupDetails.password" />
              </div>
            </div>
            
            <div class="form-group">
              <label for="confirm-password">Confirm password <span class="required">*</span></label>
              <div class="input-wrapper">
                <input type="password" id="confirm-password" v-model="signupDetails.password1" />
              </div>
            </div>
          </div>
          
          <div class="section-divider"></div>
          
          <!-- Billing Information -->
          <div class="section-header">
            <div class="section-icon">
              <span class="icon-emoji">💳</span>
            </div>
            <h3>Billing Information</h3>
          </div>
          
          <div class="form-group">
            <label for="company">Company</label>
            <div class="input-wrapper">
              <input type="text" id="company" v-model="signupDetails.company" />
            </div>
          </div>
          
          <div class="form-group">
            <label for="address">Address <span class="required">*</span></label>
            <div class="input-wrapper">
              <input type="text" id="address" v-model="signupDetails.billing_address" />
            </div>
          </div>
          
          <div class="form-row three-columns">
            <div class="form-group">
              <label for="city">City <span class="required">*</span></label>
              <div class="input-wrapper">
                <input type="text" id="city" v-model="signupDetails.city" />
              </div>
            </div>
            
            <div class="form-group">
              <label for="state">State <span class="required">*</span></label>
              <div class="input-wrapper select-wrapper">
                <select id="state" v-model="signupDetails.state">
                  <option value="" disabled selected>Select state</option>
                  <option v-for="val in myJson" :key="val">{{val}}</option>
                </select>
                <div class="select-arrow"></div>
              </div>
            </div>
            
            <div class="form-group">
              <label for="zip">Pincode <span class="required">*</span></label>
              <div class="input-wrapper">
                <input type="text" id="zip" v-model="signupDetails.zip" maxlength="6" />
              </div>
            </div>
          </div>
        </div>
        
        <!-- Right Column - Summary and Payment -->
        <div class="glass-card summary-section">
          <div class="card-accent blue"></div>
          <div class="section-header">
            <div class="section-icon">
              <span class="icon-emoji">🛒</span>
            </div>
            <h3>Subscription Summary</h3>
          </div>
          
          <div class="summary-row">
            <span class="summary-label">Number of children:</span>
            <span class="summary-value">{{signupDetails.kids.length}}</span>
          </div>
          
          <div class="pricing-details">
            <div class="pricing-row">
              <span>Price per child:</span>
              <span class="price">₹500</span>
            </div>
            
            <div class="pricing-row" v-if="signupDetails.kids.length > 1">
              <span>Price per additional child:</span>
              <span class="price">₹300</span>
            </div>
            
            <div class="pricing-row">
              <span>Duration:</span>
              <div class="duration-selector">
                <select v-model="duration">
                  <option value="1">One month</option>
                  <option value="6">Semi annual</option>
                  <option value="12">Annual</option>
                </select>
                <div class="select-arrow"></div>
              </div>
            </div>
            
            <div class="pricing-row total">
              <span>Gross amount:</span>
              <span class="price">₹{{grossAmount}}</span>
            </div>
          </div>
          
          <div class="summary-row total-row">
            <span class="summary-label">Net amount:</span>
            <span class="summary-value highlight">₹{{grossAmount}}</span>
          </div>
          
          <div class="agreement-section">
            <label class="checkbox-container">
              <input type="checkbox" v-model="agree" />
              <span class="checkmark"></span>
              <span class="checkbox-text">
                By submitting this form I agree to be contacted by you through phone, text or email
              </span>
            </label>
            
            <label class="checkbox-container">
              <input type="checkbox" v-model="term" />
              <span class="checkmark"></span>
              <span class="checkbox-text">
                I agree to Mindverse, LLC 
                <a href="https://up-skool.com/terms-of-use" target="_blank">Terms of Service</a> 
                and 
                <a href="https://up-skool.com/privacy-policy" target="_blank">Privacy Policy</a>
              </span>
            </label>
          </div>
          
          <button class="cta-button" @click="signup()" :disabled="disabled">
            <span>Complete Registration</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>
          </button>
          
          <!-- Floating Character -->
          <div class="floating-character">
            <img src="../assets/images/UP_SKOOL_LOGO.png" alt="Character" class="character-img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import json from '@/assets/data/indian_states.json'
  export default {
  name: "SignUp",
  data(){
    return{
       term:false,
       agree:false,
       duration:1,
       myJson:json,
       signupDetails:{
        name:"",
        kids:[""],
        email:"",
        email1:"",
        password:"",
        password1:"",
        mobile:"",
        company:"",
        billing_address:"",
        city:"",
        state:"",
        zip:"",
       },
    }
  },
  computed:{
    grossAmount(){
      let gross = 0
      if(this.signupDetails.kids.length == 1){
        gross = this.duration * 500;
      }
      else
      {
        gross = this.duration * 500 + (this.signupDetails.kids.length-1) * this.duration * 300;
      }
      return gross
    },
    disabled(){
      if(this.term && this.agree){
        return false;
      }
      else{
        return true;
      }
    },
  },
  methods: {
    ...mapActions([
      "signupUser",
    ]),
    addRow(){
      this.signupDetails.kids.push("");
    },
    deleteRow(kid_i){
      this.signupDetails.kids.splice(kid_i, 1)
    },
    signup(){
      console.log(this.signupDetails);
      if(this.signupDetails.email==this.signupDetails.email1 && this.signupDetails.password == this.signupDetails.password1){
        this.isLoading = true
        this.signupUser(
            this.signupDetails
        ).then((response) => {
            this.isLoading = false
            this.$buefy.toast.open({
                message: response.data.msg,
                type: 'is-success'
            })
            this.$router.push({
                name : 'login'
            })
        }).catch(err => {
            this.isLoading = false
            console.log(err);
            this.$buefy.toast.open({
                message: err.response.data,
                type: 'is-danger'
            })
        })
      }
      else{
        this.isLoading = false
        this.$buefy.toast.open({
                message: "Both email and password doesn't match",
                type: 'is-danger'
            })
      }
      
    }
  }
};
</script>

<style scoped>
/* Base Styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.signup-page {
  min-height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4rem 2rem;
  background: linear-gradient(135deg, #8a4ff8 0%, #6b38c7 100%);
  overflow: hidden;
}

/* Decorative Elements */
.decorative-circle {
  position: absolute;
  border-radius: 50%;
}

.decorative-circle.large {
  width: 400px;
  height: 400px;
}

.decorative-circle.top-right {
  top: -100px;
  right: -100px;
  background-color: #FFD600;
  opacity: 0.1;
}

.decorative-circle.bottom-left {
  bottom: -100px;
  left: -100px;
  background-color: #ffffff;
  opacity: 0.1;
}

.decorative-circle.small-yellow {
  width: 40px;
  height: 40px;
  top: 100px;
  left: 10%;
  background-color: #FFD600;
  opacity: 0.3;
}

.decorative-circle.small-blue {
  width: 30px;
  height: 30px;
  top: 50%;
  right: 8%;
  background-color: #40C4FF;
  opacity: 0.3;
}

.decorative-circle.small-white {
  width: 60px;
  height: 60px;
  bottom: 120px;
  right: 15%;
  background-color: #ffffff;
  opacity: 0.2;
}

/* Main Container */
.signup-container {
  width: 100%;
  max-width: 1200px;
  z-index: 1;
  position: relative;
}

.brand-container {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  z-index: 10;
  max-width: 4xl;
  padding: 0 1.5rem;
}

.logo {
  width: 180px;
  margin-bottom: 1.5rem;
}

.title {
  font-size: 3.5rem;
  font-weight: 900;
  color: #ffffff;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.title-highlight {
  color: #FFD600;
}

.subtitle {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.9);
  max-width: 600px;
  margin: 0 auto;
  font-weight: 300;
  line-height: 1.5;
}

/* Grid Layout */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 2.5rem;
  margin-top: 1rem;
}

/* Glass Cards */
.glass-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 2.5rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.glass-card:hover {
  transform: translateY(-5px);
}

.card-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
}

.card-accent.yellow {
  background-color: #FFD600;
}

.card-accent.blue {
  background-color: #40C4FF;
}

/* Section Headers */
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.section-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  background: rgba(255, 255, 255, 0.2);
}

.icon-emoji {
  font-size: 1.5rem;
}

.section-header h3 {
  font-size: 1.5rem;
  color: #ffffff;
  font-weight: 600;
}

/* Form Elements */
.form-group {
  margin-bottom: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.form-row.three-columns {
  grid-template-columns: 1fr 1fr 1fr;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.required {
  color: #FF9E80;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

input, select {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

input:focus, select:focus {
  outline: none;
  border-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
}

.select-wrapper {
  position: relative;
}

.select-wrapper select {
  appearance: none;
  padding-right: 30px;
}

.select-arrow {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid rgba(255, 255, 255, 0.8);
  pointer-events: none;
}

.input-row {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.8rem;
}

.flex-grow {
  flex-grow: 1;
}

/* Buttons */
.btn {
  cursor: pointer;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  color: #ffffff;
}

.btn-add {
  background: rgba(76, 175, 80, 0.7);
}

.btn-remove {
  background: rgba(255, 77, 77, 0.7);
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.section-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.2);
  margin: 2rem 0;
}

/* Summary Styling */
.summary-section {
  height: fit-content;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.summary-label {
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.summary-value {
  font-weight: 600;
  color: #ffffff;
}

.pricing-details {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1rem 0;
}

.pricing-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  color: rgba(255, 255, 255, 0.9);
}

.pricing-row:last-child {
  margin-bottom: 0;
}

.price {
  font-weight: 600;
  color: #FFD600;
}

.total-row {
  border-top: 2px solid rgba(255, 255, 255, 0.3);
  border-bottom: none;
  padding-top: 1rem;
  margin-top: 0.5rem;
}

.total-row .summary-value {
  font-size: 1.25rem;
  color: #FFD600;
  font-weight: 700;
}

.highlight {
  font-weight: 700;
}

.duration-selector {
  position: relative;
  width: 130px;
}

.duration-selector select {
  width: 100%;
  appearance: none;
  padding: 8px 30px 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

/* Checkboxes */
.agreement-section {
  margin: 1.5rem 0;
}

.checkbox-container {
  display: flex;
  margin-bottom: 1rem;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 0.9rem;
  user-select: none;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.checkbox-container:hover input ~ .checkmark {
  background-color: rgba(255, 255, 255, 0.2);
}

.checkbox-container input:checked ~ .checkmark {
  background-color: #FFD600;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-container .checkmark:after {
  left: 7px;
  top: 3px;
  width: 6px;
  height: 11px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-text {
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.9);
}

.checkbox-text a {
  color: #40C4FF;
  text-decoration: none;
}

.checkbox-text a:hover {
  text-decoration: underline;
}

/* CTA Button */
.cta-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  color: #8a4ff8;
  border: none;
  border-radius: 12px;
  padding: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1.5rem;
  gap: 0.5rem;
  width: 100%;
}

.cta-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
}

.cta-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Floating Character */
.floating-character {
  position: absolute;
  bottom: -20px;
  right: -20px;
  width: 100px;
  height: 100px;
  opacity: 0.3;
  animation: float 6s ease-in-out infinite;
}

.character-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* Responsive Styles */
@media (max-width: 1024px) {
  .form-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .signup-page {
    padding: 1.5rem;
  }
  
  .floating-character {
    display: none;
  }
}

@media (max-width: 768px) {
  .form-row, .form-row.three-columns {
    grid-template-columns: 1fr;
  }
  
  .title {
    font-size: 2.5rem;
  }
  
  .subtitle {
    font-size: 1.1rem;
  }
  
  .brand-container {
    margin-bottom: 2rem;
  }
  
  .glass-card {
    padding: 1.5rem;
  }
}

@media (max-width: 480px) {
  .title {
    font-size: 2rem;
  }
  
  .logo {
    width: 150px;
  }
  
  .signup-page {
    padding: 1rem;
  }
  
  .section-header h3 {
    font-size: 1.25rem;
  }
}
</style>